export var VideoSizeMode;
(function (VideoSizeMode) {
    VideoSizeMode["Fit"] = "fit";
    VideoSizeMode["Crop"] = "crop";
})(VideoSizeMode || (VideoSizeMode = {}));
